// Утилиты для работы с изображениями
export const IMAGE_FALLBACK_SRC = "/mocks/no-name.png";

/**
 * Обработчик ошибки загрузки изображения
 * Автоматически заменяет src на fallback изображение
 */
export const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
  e.currentTarget.src = IMAGE_FALLBACK_SRC;
};

/**
 * Получает URL изображения с fallback
 * @param photoUrl - URL фото с сервера
 * @param fallback - Fallback изображение (по умолчанию IMAGE_FALLBACK_SRC)
 */
export const getImageSrc = (
  photoUrl?: string | null,
  fallback: string = IMAGE_FALLBACK_SRC
): string => {
  return photoUrl || fallback;
};

/**
 * Создает полный URL для изображения с API
 * @param apiUrl - Базовый URL API
 * @param photoPath - Путь к фото
 */
export const buildImageUrl = (
  apiUrl: string,
  photoPath?: string | null
): string => {
  if (!photoPath) return IMAGE_FALLBACK_SRC;
  return `${apiUrl}${photoPath}`;
};
